import api from '@/api';

const initialState = {
  title: '',
  description: '',
  file_ids: [],
  vote: [],
  vote_count: 0,
};

export default {
  namespaced: true,

  state: {
    ideas: [],
    error: {},
    idea: initialState,
    votes: [],
    vote_count: 0,
  },

  mutations: {
    SET_IDEAS(state, payload) {
      state.ideas = payload;
    },
    SET_ERROR(state, payload) {
      state.error = payload;
    },
    SET_IDEA(state, payload) {
      state.idea = payload;
    },
    UPDATE_VOTE_COUNT(state) {
      state.idea.vote_count += 1;
    },
    UPDATE_VOTE_USERS(state, user) {
      if (!state.idea.vote) {
        state.idea.votes = [user];
      } else {
        state.idea.votes.push(user);
      }
    },
  },

  actions: {
    resetState({ commit }) {
      commit('SET_IDEA', { ...initialState });
    },
    async list({ commit }, params) {
      const { questionId } = params;
      let endpoint = `/collaboration/question/${questionId}/ideas/flat`;

      if (params.isFlat) {
        endpoint = `${endpoint}/flat`;
      }
      let resp;
      try {
        resp = await api().get(endpoint);
        commit('SET_IDEAS', resp.data.data.idea);
        return Promise.resolve(resp.data.data.idea);
      } catch (err) {
        // depending on the status - if it is 404 with no data, return empty array
        if (err.response.status === 404 && err.response.data.data.length == 0) {
          commit('SET_IDEAS', []);
          return Promise.resolve([]);
        }
        commit('SET_ERROR', { ...err });
        return Promise.reject(err);
      }
    },

    async create({ commit, rootState, dispatch }, payload) {
      let resp;
      const data = { idea: payload };
      const { id } = rootState.Questions.question;
      try {
        resp = await api().post(`/collaboration/question/${id}/idea`, data);
        return Promise.resolve(resp);
      } catch (error) {
        commit('SET_ERROR', error);
        return Promise.reject(error);
      }
    },

    async update({ commit, rootState, dispatch }, payload) {
      let resp;
      const data = { idea: payload };
      const { id } = rootState.Questions.question;
      try {
        resp = await api().post(`/collaboration/question/${id}/idea/${payload.id}`, data);
        return Promise.resolve(resp);
      } catch (error) {
        commit('SET_ERROR', error);
        return Promise.reject(error);
      }
    },
    async resubmit({ commit, rootState, dispatch }, payload) {
      let resp;
      const data = { idea: payload };
      const { id } = rootState.Questions.question;
      try {
        resp = await api().post(`/collaboration/question/${id}/idea/${payload.id}/resubmit`, data);
        return Promise.resolve(resp);
      } catch (error) {
        commit('SET_ERROR', error);
        return Promise.reject(error);
      }
    },

    async read({ commit }, { questionId, ideaId }) {
      let resp;
      try {
        resp = await api().get(`/collaboration/question/${questionId}/idea/${ideaId}`);
        commit('SET_IDEA', resp.data.data.idea[0]);
        return Promise.resolve(resp.data.data.idea[0]);
      } catch (error) {
        commit('SET_ERROR', error);
        return Promise.reject(error);
      }
    },

    /**
     * Vote for an idea, once we have voted, increment vote counters
     * @param {*} param0
     * @param {*} param1
     */
    async vote({ state, dispatch }, { questionId, ideaId }) {
      let resp;
      try {
        resp = await api().put(`/collaboration/question/${questionId}/idea/${ideaId}/vote`);
        dispatch('read', { questionId, ideaId });
        return Promise.resolve(resp);
      } catch (error) {
        return Promise.reject(error.response.data.errors[0].message);
      }
    },

    /**
     * Same as above, but unvote
     */
    async unvote({ state, dispatch }, { questionId, ideaId }) {
      let resp;
      try {
        resp = await api().put(`/collaboration/question/${questionId}/idea/${ideaId}/unvote`);
        dispatch('read', { questionId, ideaId });
        return Promise.resolve(resp);
      } catch (error) {
        return Promise.reject(error.response.data.errors[0].message);
      }
    },

    async implement({ state }, { questionId, ideaId }) {
      let resp;

      try {
        resp = await api().put(`/collaboration/question/${questionId}/idea/${ideaId}/implement`);
        return Promise.resolve(resp);
      } catch (error) {
        return Promise.reject(error.response.data.errors[0].message);
      }
    },

    async decline({ state }, { questionId, ideaId }) {
      let resp;

      try {
        resp = await api().put(`/collaboration/question/${questionId}/idea/${ideaId}/decline`);
        return Promise.resolve(resp);
      } catch (error) {
        return Promise.reject(error.response.data.errors[0].message);
      }
    },

    async delete(context, { questionId, ideaId }) {
      let resp;

      try {
        resp = await api().delete(`/collaboration/question/${questionId}/idea/${ideaId}`);
        return Promise.resolve(resp);
      } catch (error) {
        return Promise.reject(error.response.data.errors[0].message);
      }
    },

    async review({ state }, feedback) {
      const questionId = state.idea.question_id;
      const ideaId = state.idea.id;

      const payload = { review: { reason: feedback } };

      let response;

      try {
        response = api().post(
          `/collaboration/question/${questionId}/idea/${ideaId}/review`,
          payload,
        );
        return Promise.resolve(response);
      } catch (err) {
        console.log({ ...err });
        return Promise.reject(err);
      }
    },

    updateVotes({ commit, rootState }) {
      commit('UPDATE_VOTE_COUNT');
      commit('UPDATE_VOTE_USERS', rootState.auth.currentUser);
    },
  },
};
